import { render, staticRenderFns } from "./vManutencao.vue?vue&type=template&id=65adf5c1&scoped=true"
import script from "./vManutencao.vue?vue&type=script&lang=js"
export * from "./vManutencao.vue?vue&type=script&lang=js"
import style0 from "./vManutencao.vue?vue&type=style&index=0&id=65adf5c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65adf5c1",
  null
  
)

export default component.exports